export default "__VITE_ASSET__DDQjlsrG__"